import { buffers, eventChannel, END } from 'redux-saga'
import { takeLatest, takeEvery, call, put, select, fork, take, cancel, delay } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import moment from 'moment'
import CommonFunctionsUtils from '../../utils/CommonFunctionsUtils'
import { doc, getDoc, deleteDoc, getDocs, collection, setDoc, updateDoc, arrayUnion, where, query} from "@firebase/firestore";
import LogRocket from 'logrocket';
import * as routes from '../../constants/routes'
import SettingsUtils from '../../utils/SettingsUtils'
import EntityUtils from '../../utils/EntityUtils';

import { DateTime, Settings } from "luxon";
import {
  LOAD_CUSTOMERS_ACTION,
  CREATE_CUSTOMER_ACTION,
  UPDATE_CUSTOMER_ACTION,
  DELETE_CUSTOMER_ACTION,
  UPDATE_PRICING_MATRIX,
  LOAD_USER_PROFILE,
  FETCH_WORKFLOWS, SAVE_WORKFLOW, SYNC_WORKFLOWS, DELETE_WORKFLOW,

  LOAD_COMPANY_ACTION,
  CREATE_COMPANY_ACTION,
  UPDATE_COMPANY_ACTION,

  UPDATE_PLAN_ACTION,

  AUTH_USER_SET,

  SUBSCRIBE_ACTION,

  STRIPE_CONNECT_ACTION,

  LOAD_CC_GATEWAY_ACTION,

  LOAD_TIME_ENTRIES_ACTION,

  CREATE_DOCUMENT_ACTION,
  UPDATE_DOCUMENT_ACTION,
  DELETE_DOCUMENT_ACTION,

  CREATE_DOCUMENT_INSTANCE_ACTION,
  UPDATE_DOCUMENT_INSTANCE_ACTION,
  DELETE_DOCUMENT_INSTANCE_ACTION,
  SHARE_DOCUMENT_INSTANCE_ACTION,

  UPDATE_USER_CONFIGS,
  LOAD_USER_CONFIGS,
  LOAD_USER_CONFIGS_SUCCESS,

  LOAD_COMPANY_MEMBERS_ACTION,
  LOAD_COMPANY_MEMBERS_SUCCESS_ACTION,

  DELETE_CART_CONFIGURATION,
  DELETE_CART_CONFIGURATION_SUCCESS,
  DELETE_CART_CONFIGURATION_FAILURE,
  SAVE_CART_CONFIGURATION,
  SAVE_CART_CONFIGURATION_SUCCESS,
  SAVE_CART_CONFIGURATION_FAILURE,
  FETCH_CART_CONFIGURATIONS,
  FETCH_CART_CONFIGURATIONS_SUCCESS,
  FETCH_CART_CONFIGURATIONS_FAILURE,
  SAVE_EMBED_CONFIGURATION,
  SAVE_EMBED_CONFIGURATION_SUCCESS,
  SAVE_EMBED_CONFIGURATION_FAILURE,
  FETCH_EMBED_CONFIGURATIONS,
  FETCH_EMBED_CONFIGURATIONS_SUCCESS,
  SYNC_EMBED_CONFIGURATIONS,
  SYNC_CART_CONFIGURATIONS,
  DELETE_EMBED_CONFIGURATION,

  UPDATE_USER_ACTION,

  DELETE_PRODUCT,
  DELETE_VARIANT,
  DELETE_DISCOUNT,
  FETCH_PRODUCTS,
  FETCH_VARIANTS,
  FETCH_DISCOUNTS,
  SAVE_PRODUCT,
  SAVE_VARIANT,
  SAVE_DISCOUNT,
  SYNC_PRODUCTS,
  SYNC_VARIANTS,
  SYNC_DISCOUNTS,

  QB_SYNC_INVOICES_ACTION,
  QB_SYNC_CUSTOMERS_ACTION,
  SYNC_CONNECTED_ACCOUNTS,
  SAVE_CONNECTED_ACCOUNT,
  FETCH_CONNECTED_ACCOUNTS_SUCCESS,
  FETCH_CONNECTED_COMPANIES,

  FETCH_API_KEYS,
} from './constants';

import {
  loadCustomersSuccess,
  loadCustomersFailure,
  createCustomerSuccess,
  createCustomerFailure,
  updateCustomerSuccess,
  updateCustomerFailure,

  loadCompanySuccess,
  loadCompanyFailure,
  createCompanySuccess,
  createCompanyFailure,
  updateCompanySuccess,
  updateCompanyFailure,
  loadCompanyPlanSuccess,
  updatePlanSuccess,
  updatePlanFailure,
  loadProfileSuccess,
  loadInvoicesSuccess,
  loadUserProfile,
  authUserSuccess,
  docketShopValidationFailure,

  subscribeSuccess,
  subscribeFailure,

  loadccGatewaySuccess,

  loadPayments,

  loadUserConfigsSuccess,
  updateUserConfigs,
  updateUserConfigsSuccess,
  loadIntregrations,
  loadUnpaidInvoicesSuccess,

  loadReferralsSuccess,

  syncInvoice,
  QBSyncFinished,
} from './actions';
import appActions from './actions'

import { rsf, firebaseApp, firestore, messaging, reduxSagaFirebase, db, auth } from '../../firebaseConfig'

import appSelector from './selectors'
import { BASE_URL, DOCKET_API_URLS, DOCKET_REQUEST_EVENT_TYPES, docketApi } from '../../constants/api';
import cloneDeep from 'lodash/cloneDeep'

import firestoreUtils from '../../utils/firestore'
import {
  DOCKET_SHOP_VALIDATION_UNAVAILABLE,
  validateDocketShopTeam,
} from './docketShopValidation';
const errorAPI = "https://hooks.slack.com/services/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"
import { encrypt, decrypt } from 'salteen';
import { getDocketAPIKey } from '../../utils/integrations';

export function* loadCustomers() {

}

export function* syncCustomers() {
  const authUser = yield select(appSelector.selectAuthUser());

  const team = yield select(appSelector.selectTeam());
  if (team !== undefined) {
    yield fork(
      rsf.firestore.syncCollection,
      firestore.collection(`companies/${team.id}/customers`),
      {
        successActionCreator: loadCustomersSuccess,
        transform: firestoreUtils.customerListTransform
      }
    )
  }
}

export function* syncDocuments() {
  const team = yield select(appSelector.selectTeam());
  if (team !== null && team !== undefined) {
    yield fork(
      rsf.firestore.syncCollection,
      firestore.collection('documents').where('companyId', '==', team.id),
      {
        successActionCreator: appActions.loadDocuments,
        transform: firestoreUtils.simpleTransform
      }
    )
  }
}

export function* syncIntegrations() {
  const team = yield select(appSelector.selectTeam());
  yield fork(
    rsf.firestore.syncDocument,
    firestore.doc(`integrations/${team.id}`),
    {
      successActionCreator: loadIntregrations,
      transform: firestoreUtils.documentTransform
    }
  )
}

export function* syncUserConfigs() {
  try {
    const profile = yield select(appSelector.selectProfile());
    yield fork(
      rsf.firestore.syncDocument,
      `configs/${profile.uid}`,
      {
        successActionCreator: loadUserConfigsSuccess,
        transform: firestoreUtils.documentTransform
      }
    )
  } catch (e) {
    console.error(e)
  }
}

export function* updateUserConfig(action) {
  try {
    const profile = yield select(appSelector.selectProfile());
    if (profile.uid) {
      let update = JSON.parse(JSON.stringify(action.configs))
      update.lastUpdate = (new Date()).getTime()
      let v = yield call(rsf.firestore.setDocument, `configs/${profile.uid}`, update, { merge: true });
      yield put(updateUserConfigsSuccess(action.configs))
    }
  } catch (err) {
    console.error("updateUserConfig", err)
  }
}

export function* fetchCartConfigurations(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    const companyId = company.id;
    const configRef = collection(firestore, `companies/${companyId}/portalConfigs`);
    const configsSnapshot = yield call(getDocs, configRef);
    const configs = firestoreUtils.collectionToMap(configsSnapshot);
    yield put(appActions.fetchCartConfigurationsSuccess({
      configs: configs
    }));
  } catch (e) {
    console.error(e);
    yield put(appActions.fetchCartConfigurationsFailure(e));
  }
}

export function* fetchEmbedConfigurations(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    const companyId = company.id;
    const configRef = collection(firestore, `companies/${companyId}/embedConfigs`);
    const configsSnapshot = yield call(getDocs, configRef);
    const configs = firestoreUtils.collectionToMap(configsSnapshot);
    yield put(appActions.fetchEmbedConfigurationsSuccess({
      embedConfigurations: configs
    }));
  } catch (e) {
    console.error(e);
    yield put(appActions.fetchEmbedConfigurationsFailure(e));
  }
}

export function* saveCartConfiguration(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    let configToSave = action.params.config;
    let configRef;
    if (configToSave.id) {
      configRef = doc(firestore, `companies/${company.id}/portalConfigs/${configToSave.id}`);
    } else {
      configRef = doc(collection(firestore, `companies/${company.id}/portalConfigs`));
      configToSave.id = configRef.id;
    }

    configToSave.staged = false;

    const configSnapshot = yield call(setDoc, configRef, configToSave);
    yield put(appActions.saveCartConfigurationSuccess());
  } catch (e) {
    console.error(e);
    yield put(appActions.saveCartConfigurationFailure(e));
  }
}



export function* syncEmbedConfigurations(action) {
  try {
    const company = yield select(appSelector.selectCompany());
    if (company != null) {
      yield fork(
        rsf.firestore.syncCollection,
        `companies/${company.id}/embedConfigs`,
        {
          successActionCreator: appActions.fetchEmbedConfigurationsSuccess,
          transform: firestoreUtils.simpleTransform
        }
      )
    }
  } catch (e) {
    debugger;
    console.error(e);
  }
}

export function* syncCartConfigurations(action) {
  try {
    const company = yield select(appSelector.selectCompany());
    if (company != null) {
      yield fork(
        rsf.firestore.syncCollection,
        `companies/${company.id}/portalConfigs`,
        {
          successActionCreator: appActions.fetchCartConfigurationsSuccess,
          transform: firestoreUtils.simpleTransform
        }
      )
    }
  } catch (e) {
    debugger;
    console.error(e);
  }
}

export function* saveEmbedConfiguration(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    let configToSave = action.params.config;
    let configRef;
    if (configToSave.id) {
      configRef = doc(firestore, `companies/${company.id}/embedConfigs/${configToSave.id}`);
    } else {
      configRef = doc(collection(firestore, `companies/${company.id}/embedConfigs`));
      configToSave.id = configRef.id;
    }

    configToSave.staged = false;

    const configSnapshot = yield call(setDoc, configRef, configToSave);
    yield put(appActions.saveEmbedConfigurationSuccess());
  } catch (e) {
    console.error(e);
    yield put(appActions.saveEmbedConfigurationFailure(e));
  }
}

export function* deleteEmbedConfiguration(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    let configToDelete = action.params.config;
    let configRef;
    if (configToDelete) {
      configRef = doc(firestore, `companies/${company.id}/embedConfigs/${configToDelete.id}`);
      yield call(deleteDoc, configRef);
      yield put(appActions.deleteEmbedConfigurationSuccess());
    } else {
      throw "No config to delete"
    }
  } catch (e) {
    console.error(e);
    yield put(appActions.deleteEmbedConfigurationFailure(e));
  }
}

export function* deleteCartConfiguration(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    let configToDelete = action.params.cartConfiguration;
    let configRef;
    if (configToDelete) {
      configRef = doc(firestore, `companies/${company.id}/portalConfigs/${configToDelete.id}`);
      yield call(deleteDoc, configRef);
      yield put(appActions.deleteCartConfigurationSuccess());
    } else {
      throw "No configuration to delete"
    }
  } catch (e) {
    console.error(e);
    yield put(appActions.deleteCartConfigurationFailure(e));
  }
}


export function* createDocument(action) {
  try {
    const team = yield select(appSelector.selectTeam());
    const member = yield select(appSelector.selectMemberProfile());
    if (team !== undefined) {
      let attachments = []
      for (let i in action.document.attachments) {
        let file = action.document.attachments[i]
        let rand = `${Math.random().toString().replace('.', '_')}`
        let filePath = `public/company/${team.id}/files/documents/${rand}/${CommonFunctionsUtils.isFilenameValid(file.name)}`
        if (file.type.startsWith('image/')) {
          file = yield call(CommonFunctionsUtils.resizeImage, {
            file: file,
            maxSize: 1024
          });
        }
        const task = rsf.storage.uploadFile(filePath, file, { 'contentType': file.type })
        yield task
        let url = yield call(rsf.storage.getDownloadURL, filePath)

        let preview = url
        if (file.type.startsWith('image/')) {
          const previewFile = yield call(CommonFunctionsUtils.resizeImage, {
            file: file,
            maxSize: 50
          });
          const previewPath = `public/company/${team.id}/files/documents/${rand}/thumb_${CommonFunctionsUtils.isFilenameValid(file.name)}`
          const task2 = rsf.storage.uploadFile(previewPath, previewFile, { 'contentType': file.type })
          yield task2
          preview = yield call(rsf.storage.getDownloadURL, previewPath)
        }

        let atch = { src: url, name: file.name, type: file.type, preview }
        attachments.push(atch)
      }
      action.document.attachments = attachments
      action.document.companyId = team.id
      action.document.createdOn = moment().valueOf()
      action.document.uploadedBy = member.memberId
      action.document.active = true
      let ref = yield call(rsf.firestore.addDocument, `documents`, JSON.parse(JSON.stringify(action.document)))
      yield call(rsf.firestore.updateDocument, `documents/${ref.id}`, {
        id: ref.id
      });

      if (action.callback !== undefined) {
        let callbackDocument = action.document
        callbackDocument.id = ref.id
        action.callback(callbackDocument)
      }
    }
  }
  catch (e) {
    console.error('Count not create Document')
  }
}

export function* updateDocument(action) {
  yield call(rsf.firestore.updateDocument, `documents/${action.document.id}`, action.document)
}

export function* deleteDocument(action) {
  action.document.active = false
  yield call(rsf.firestore.updateDocument, `documents/${action.document.id}`, action.document)
}

export function* createDocumentInstance(action) {
  try {
    const team = yield select(appSelector.selectTeam());
    const member = yield select(appSelector.selectMemberProfile());
    if (team !== undefined) {
      action.documentInstance.companyId = team.id
      action.documentInstance.createdOn = moment().valueOf()
      action.documentInstance.createdBy = member.memberId
      action.documentInstance.active = true
      let ref = yield call(rsf.firestore.addDocument, `documentInstances`, JSON.parse(JSON.stringify(action.documentInstance)))
      yield call(rsf.firestore.updateDocument, `documentInstances/${ref.id}`, {
        id: ref.id
      });

      if (action.callback !== undefined) {
        let callbackDocumentInstance = action.documentInstance
        callbackDocumentInstance.id = ref.id
        action.callback(callbackDocumentInstance)
      }
    }
  } catch (e) {
    console.error('Count not create Document Instance')
  }
}

export function* updateDocumentInstance(action) {
  const team = yield select(appSelector.selectTeam());
  if (team !== undefined) {
    yield call(rsf.firestore.updateDocument, `documentInstances/${action.documentInstance.id}`, action.documentInstance)
  }
}

export function* deleteDocumentInstance(action) {
  action.documentInstance.active = false
  yield call(rsf.firestore.updateDocument, `documentInstances/${action.documentInstance.id}`, action.documentInstance)
}

export function* shareDocumentInstance(action) {
  try {
    const member = yield select(appSelector.selectMemberProfile());
    let documentInstance = action.documentInstance
    documentInstance.shared = true
    documentInstance.sender = member.memberId
    documentInstance.senderName = { first: member.name.first, last: member.name.last }
    documentInstance.shareDate = moment().valueOf()
    let history = documentInstance.history
    if (history === undefined) {
      history = {}
    }
    history[documentInstance.shareDate] = {
      shareDate: documentInstance.shareDate,
      senderName: documentInstance.senderName,
      sender: documentInstance.sender
    }
    documentInstance.history = history
    documentInstance = cloneDeep(documentInstance)
    yield put(appActions.updateDocumentInstance(documentInstance))
  } catch (e) {
    console.error('Count not share document instance')
  }
}

export function* createCustomer(action) {
  try {
    let customer = action.customer
    customer.active = true
    const team = yield select(appSelector.selectTeam());
    const member = yield select(appSelector.selectMemberProfile());
    customer.companyId = team.id
    customer.createdOn = moment().valueOf()
    customer.type = 'Client'
    customer.createdBy = member.memberId
    try {
      customer.email = customer.email.toLowerCase()
    } catch (e) { }
    let snapShot = yield call(rsf.firestore.addDocument, `customers`, customer)
    customer.id = snapShot.id
    yield put(createCustomerSuccess(customer))

    if (action.callback !== undefined) {
      let callbackCustomer = customer
      callbackCustomer.id = snapShot.id
      action.callback(callbackCustomer)
    }
  } catch (e) {
    console.error('Count not create Customer')
  }
}

export function* loadCompany() {
  const profile = yield select(appSelector.selectProfile());
  const company = yield select(appSelector.selectTeam());

  try {
    const snapshot = yield call(rsf.firestore.getDocument, `companies/${company.id}`);
    const companyData = snapshot.data();

    let memberId = profile.companies[profile.selectedCompany].memberId
    const memberProfile = (yield call(rsf.firestore.getDocument, `companies/${company.id}/members/${memberId}`)).data();

    yield put(loadCompanySuccess(companyData, memberProfile))
    yield put(loadProfileSuccess(profile))
    yield put(appActions.syncCartConfigurations());
    yield put(appActions.syncEmbedConfigurations());
    yield put(appActions.fetchWorkflows());
    yield put(appActions.syncWorkflows());
    yield put(appActions.syncConnectedAccounts());
    yield put(appActions.fetchApiKeys());
  }
  catch (e) {
    console.log(e);
    yield put(loadCompanyFailure(e))
  }
}

export function* createCompany(company) {

}

export function* updateCompany(action) {
  const profile = yield select(appSelector.selectProfile());

  const team = yield select(appSelector.selectTeam());
  let company = JSON.parse(JSON.stringify(action.company))

  try {
    if(company.properties && company.properties.email){
      let domain = company.properties.email ? company.properties.email.split('@')[1] : ''
      company.properties.email= company.properties.email ? company.properties.email.toLowerCase() : company.properties.email
      company.properties.emailDomain = domain
    }
    yield call(rsf.firestore.updateDocument, `companies/${team.id}`, company);
    let updateKey = `companies.${team.id}.businessName`
    let data = {}
    data[`companies.${team.id}.businessName`] = company.properties.businessName
    yield call(rsf.firestore.updateDocument, `users/${profile.uid}`, data);
    yield put(updateCompanySuccess(company, undefined))

  }
  catch (e) {
    yield put(updateCompanyFailure(e))
  }
}

export function* updateUser(action) {
  let user = JSON.parse(JSON.stringify(action.user))
  try {
    yield call(rsf.firestore.updateDocument, `users/${user.uid}`, user);
    action.cb()
  }
  catch (e) {
    console.error('Failed to update user:', e);
  }
}

export function* updatePlan(action) {
  const team = yield select(appSelector.selectTeam());
  let plan = JSON.parse(JSON.stringify(action.plan))
  try {
    yield call(rsf.firestore.updateDocument, `plans/${team.id}`, plan);
    yield put(updatePlanSuccess(plan, undefined))
  }
  catch (e) {
    yield put(updatePlanFailure(e))
  }
}

export function* updateCustomer(action) {
  let customer = JSON.parse(JSON.stringify(action.customer))
  delete customer.serviceAddress
  try {
    customer.email = customer.email.toLowerCase()
  } catch (e) { }
  try {
    yield call(rsf.firestore.setDocument, `customers/${customer.id}`, customer);

    yield put(updateCustomerSuccess(customer))
  }
  catch (e) {
    yield put(updateCustomerFailure(e))
  }
}

function* deleteCustomer(action) {
  action.customer.active = false
  let cid = action.customer.id
  yield call(rsf.firestore.updateDocument, `companies/${action.customer.companyId}/customers/${cid[0]}`, { [cid]: action.customer });
  yield call(updateCustomer, action)
}

function getQueryParams() {
  try {
    var query = window.location.search.substring(1);
    let pairs = {}
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      pairs[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return pairs
  } catch (e) {
    return {}
  }
}

export function* loadProfile() {
  let startTime = (new Date()).getTime()
  window.stats = {}
  const authUser = yield select(appSelector.selectLoadingProfileAuthUser());
  if (typeof authUser !== "undefined" && authUser !== null) {
    let params = getQueryParams()

    let snapshot = undefined
    try {
      if (params.u) {
        let decryptor = decrypt(authUser.uid)
        let uid = decryptor(params.u)  //prevents copy paste access
        snapshot = yield firestore.collection('users').doc(uid).get();
      }
      else {
        snapshot = yield firestore.collection('users').doc(authUser.uid).get();
      }
    } catch (e) {
      if (params.expectedTeamId) {
        yield put(docketShopValidationFailure(DOCKET_SHOP_VALIDATION_UNAVAILABLE));
        yield put(authUserSuccess(authUser));
        return;
      }
      throw e;
    }

    const profile = snapshot.data();

    const validationError = validateDocketShopTeam(profile, params.expectedTeamId);
    if (validationError) {
      yield put(docketShopValidationFailure(validationError));
      yield put(authUserSuccess(authUser));
      return;
    }

    if (profile === undefined || profile === null) {
      yield put(push(routes.NO_ACCESS));
      return;
    }

    if (params.u) {
      //using param user so verify this user has the
      let g = async function () {
        return await authUser.getIdTokenResult()
      }
      let claims = yield call(g)
      if (claims.claims['super'] !== true) {
        if (profile.roles === undefined || profile.roles.indexOf('LINKED') === -1) {
          yield put(push(routes.NO_ACCESS));
          return;
        }
      }
    }
    window.stats.fetchuser = ((new Date()).getTime() - startTime) + "ms"
    yield put(loadUserProfile(profile));
    window.stats.setProfile = ((new Date()).getTime() - startTime) + "ms"
    yield put(authUserSuccess(authUser));
    window.stats.setProfile = ((new Date()).getTime() - startTime) + "ms"

    // This is an example script - don't forget to change it!
    let idData = {
      name: profile.displayName,
      companyId: profile.selectedCompany
    }
    try {
      idData.version = document.getElementById('versionTag').textContent

    } catch (e) { }
    if (profile.uid) {
      LogRocket.identify(profile.uid, idData);
    }

    yield put(appActions.loadccGateway(profile.selectedCompany))
    yield put(appActions.loadCompany())
    yield put(appActions.loadCompanyMembers());
    yield fork(loadCompanyMembers)
    yield fork(syncUserConfigs);

    try {
      $zoho.salesiq.visitor.name(profile.displayName);
      $zoho.salesiq.visitor.info({ "teamId": profile.selectedCompany, "company": profile.companies[profile.selectedCompany].businessName });
      $('#titlediv').remove()
    } catch (e) { }

    window.stats.profileLoaded = ((new Date()).getTime() - startTime) + "ms"

    try {
      var Sys = {};
      var ua = navigator.userAgent.toLowerCase();
      var s;
      (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
        (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
          (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
            (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
              (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 0;

      let key = s[0] + " -- " + s[1]
      let clients = {}
      clients[key] = {
        resolution: {
          height: window.screen.height,
          width: window.screen.width
        }
      }

      yield put(updateUserConfigs({ clients, lastLogin: moment().valueOf() }))
    } catch (e) {

    }

    yield delay(500)
  }
}

export function* syncUnpaidInvoices() {
  const team = yield select(appSelector.selectTeam());
  if (team !== undefined) {
    yield fork(
      rsf.firestore.syncCollection,
      firestore.collection(`companies/${team.id}/abridgedInvoices`).where('active', "==", true).where('balance', '>', 0), {
      successActionCreator: loadUnpaidInvoicesSuccess,
      transform: firestoreUtils.simpleTransform
    }
    )
  }

}
export function* syncPayments() {
  const team = yield select(appSelector.selectTeam());
  if (team !== undefined) {
    while (true) {
      let action = yield take('START_INVOICE_DATESPAN_SYNCH')
      const syncher1 = yield fork(
        rsf.firestore.syncCollection,
        firestore.collection('payment').where('companyId', '==', team.id).where('invoiceDate', '>=', action.start).where('invoiceDate', '<=', action.end), {
        successActionCreator: loadPayments,
        transform: firestoreUtils.simpleTransform
      }
      )
      yield take('STOP_INVOICE_DATESPAN_SYNCH')
      yield cancel(syncher1)
    }
  }
}


export function* loadCompanyMembers() {
  try {
    const team = yield select(appSelector.selectTeam());
    const members = yield firestore.collection(`companies/${team.id}/members`).get();
    const membersSnapshot = firestoreUtils.simpleTransform(members);
    yield put(appActions.loadCompanyMembersSuccess(membersSnapshot));
  } catch (e) {
    yield put(loadCompanyFailure(e))
  }
}

export function* subscribe(action) {
  const authUser = yield select(appSelector.selectAuthUser());
  const team = yield select(appSelector.selectTeam());
  const member = yield select(appSelector.selectMemberProfile());
  try {

    function fetchData(params) {
      return fetch(`${BASE_URL}/httpStripeSubscribe`, params).then(response => (
        (response.status === 200) ? response.json() : Promise.reject('logon')
      ));
    }

    let token = action.token.token !== undefined ? action.token.token : action.token
    const res = yield call(fetchData, {
      method: 'POST',
      body: JSON.stringify({
        token,
        companyId: team.id,
        plan: action.plan,
        customerId: team.stripeCustomerId,
        amount: action.amount,
        memberId: member.memberId,
        coupon: action.coupon,
      }),
    });
    if (res.valid) {
      const snapshot = yield firestore.collection('companies').doc(team.id).get();
      const company = snapshot.data();
      yield put(loadCompanySuccess(company, undefined))
      yield put(subscribeSuccess(res));
      yield put(push(`/account#plan`));
    }
    else {
      let message = res.err.message ? res.err.message : res.err.raw.message
      message = message ? message : 'There was an error processing your payment.'
      if (message.indexOf(';') > -1) {
        message = message.split(';')[0]
      }
      yield put(subscribeFailure(message))
    }
  }
  catch (e) {
    yield put(subscribeFailure("Could not process your subscription. Please try again."))
  }
}

export function* stripeConnect(action) {
  const team = yield select(appSelector.selectTeam());
  try {
    let gateway = {
      type: 'STRIPE',
      accountId: action.accountId,
      passOnFees: false,
      applicationFee: 20,
      businessName: team.properties.businessName
    }
    let gatewayPublic = {
      type: 'STRIPE',
      accountId: action.accountId,
      businessName: team.properties.businessName
    }
    yield call(rsf.firestore.setDocument, `ccGateway/${action.companyId}`, JSON.parse(JSON.stringify(gateway)), { merge: true })
    yield call(rsf.firestore.setDocument, `ccGatewayPublic/${action.companyId}`, JSON.parse(JSON.stringify(gatewayPublic)), { merge: true })
    yield call(rsf.firestore.updateDocument, `companies/${team.id}`, { ccGateway: "STRIPE" });

    yield put(loadccGatewaySuccess(gatewayPublic))
  }
  catch (e) {
    yield put({
      type: 'FAILURE',
      error: e,
      title: "Could not connect your stripe account.",
      message: "There was an issue connecting your account. We've logged your error and will address it immediately. Please give us a call at (937) 468-5700 or send us an email support@yourdocket.com"
    });
  }
}

export function* loadccGateway(action) {
  try {
    const snapshot = yield firestore.doc(`ccGatewayPublic/${action.companyId}`).get();
    const ccGateway = snapshot.data();
    yield put(loadccGatewaySuccess(ccGateway))
  } catch (err) {
    console.error(err);
  }
}

function* failureNotifier(action) {
  const team = yield select(appSelector.selectTeam());
  const member = yield select(appSelector.selectMemberProfile());
  let name = ''
  if (member) {
    if (member.name) {
      if (member.name.first) {
        name += member.name.first
      }
      if (member.name.last) {
        name += ' ' + member.name.last
      }
    }
  }
  if(action.showUser === undefined || action.showUser === true){
    toastr.error(action.title, action.message)
  }
  try {
    let mesg = { text: `ERROR:: ${team.id} - (${team.properties.businessName ? team.properties.businessName : ''}) - (${name})\nVersion: ${document.getElementById('versionTag').textContent}\n${action.title}\n\n${window.location.href}\n${JSON.stringify(action.error)}` }
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(mesg)
    };
    fetch('https://hooks.slack.com/services/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', requestOptions);
  } catch (e) { }
}

export function* QBSyncInvoices(action) {
  const team = yield select(appSelector.selectTeam());
  try {

    function fetchData(params) {
      return fetch(`${BASE_URL}/httpIntegrationsQuickbooksApi`, params)
        .then((res) => {
          if (res.status === 400) {
            throw new Error('We could not communicate with Quickbook at this time.');
          }
          return res.json();
        })
        .then(json => {
          return json
          // handle response normally here
        })
        .catch(ex => {
          toastr.error("Sync Failed", ex)
          // handle errors here
        });
    }

    function loadInvoices() {
      return new Promise(async resolve => {
        let invoices = []
        let promises = []
        for (let inv of action.invoices) {
          if (inv.abridged) {
            if (inv.id) {
              promises.push(firestore.doc(`invoices/${inv.id}`).get())
            }
          } else {
            invoices.push(inv)
          }
        }
        await Promise.all(promises).then(data => {
          for (let snap of data) {
            let d = snap.data()
            delete d.terms
            delete d.greeting
            invoices.push(d)
          }
        })
        resolve(invoices)
      })

    }
    //We need to get real invoices not abridged
    let invoices = yield call(loadInvoices)
    const res = yield call(fetchData, {
      method: 'POST',
      body: JSON.stringify({
        action: 'SYNC_INVOICES',
        companyId: team.id,
        invoices: invoices,
        customers: action.customers
      }),
    });

    yield put({
      type: 'app/App/QB_SYNC_FINSISHED_ACTION'
    })
  }
  catch (e) {
    console.error('Could not process subscription.')
  }
}

export function* QBSyncCustomers(action) {
  const team = yield select(appSelector.selectTeam());
  try {

    function fetchData(params) {
      return fetch(`${BASE_URL}/httpIntegrationsQuickbooksApi`, params)
        .then((res) => {
          if (res.status === 400) {
            throw new Error('We could not communicate with Quickbook at this time.');
          }
          return res.json();
        })
        .then(json => {
          return json
          // handle response normally here
        })
        .catch(ex => {
          toastr.error("Sync Failed", ex)
          // handle errors here
        });
    }

    //We need to get real invoices not abridged
    const res = yield call(fetchData, {
      method: 'POST',
      body: JSON.stringify({
        action: 'SYNC_CUSTOMERS',
        companyId: team.id,
        customers: action.customers
      }),
    });

    yield put({
      type: 'app/App/QB_SYNC_FINSISHED_ACTION'
    })
  }
  catch (e) {
    console.error('Could not process subscription.')
  }
}

export function* fetchProducts(action) {
  console.log("fetching products");
  const company = yield select(appSelector.selectCompany());
  try {
    const products = yield firestore.collection(`companies/${company.id}/products`).get();
    const productsSnapshot = firestoreUtils.simpleTransform(products);
    yield put(appActions.fetchProductsSuccess(productsSnapshot));
  } catch (e) {
    yield put(appActions.fetchProductsFailure({
      error: e
    }));
  }
}

export function* fetchApiKeys(action) {
  const company = yield select(appSelector.selectCompany());
  try {
    const keys = yield firestore.collection('apiKeys').where('companyId', '==', company.id).get();
    const apiMap = firestoreUtils.transformApiKeys(keys);
    yield put(appActions.fetchApiKeysSuccess(apiMap));
  } catch (e) {
    console.error(e);
  }
}

export function* syncProducts(action) {
  try {
    const company = yield select(appSelector.selectCompany());
    if (company != null) {
      let q = query(collection(firestore, `companies/${company.id}/products`), where('active', '==', true));
      yield fork(
        rsf.firestore.syncCollection,
        q,
        {
          successActionCreator: appActions.fetchProductsSuccess,
          transform: firestoreUtils.simpleTransform
        }
      )
    }
  } catch (e) {
    debugger;
    console.error(e);
  }
}

export function* fetchVariants(action) {
  console.log("fetching variants");
  const company = yield select(appSelector.selectCompany());
  try {
    const { productId } = action.params;
    const variants = yield firestore.collection(`companies/${company.id}/products/${productId}/variants`).get();
    const variantsSnapshot = firestoreUtils.simpleTransform(variants);
    yield put(appActions.fetchVariantsSuccess({
      variants: variantsSnapshot,
      productId: productId
    }));
  } catch (e) {
    yield put(appActions.fetchVariantsFailure({
      error: e
    }));
  }
}

export function* syncDiscounts(action) {
  try {
    const company = yield select(appSelector.selectCompany());
    if (company != null) {
      yield fork(
        rsf.firestore.syncCollection,
        `companies/${company.id}/discounts`,
        {
          successActionCreator: appActions.fetchDiscountsSuccess,
          transform: firestoreUtils.simpleTransform
        }
      )
    }
  } catch (e) {
    debugger;
    console.error(e);
  }
}

export function* syncVariants(action) {
  try {
    const company = yield select(appSelector.selectCompany());
    if (company != null) {
      const { productId } = action.params;
      const transform = function(collection) {
        return {
          variants: firestoreUtils.simpleTransform(collection),
          productId: productId
        }
      }
      yield fork(
        rsf.firestore.syncCollection,
        `companies/${company.id}/products/${productId}/variants`,
        {
          successActionCreator: appActions.fetchVariantsSuccess,
          transform: transform
        }
      )
    }
  } catch (e) {
    debugger;
    console.error(e);
  }
}

export function* saveDiscount(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    let discountToSave = action.params.discount;
    let discountRef;
    if (discountToSave.id) {
      discountRef = doc(firestore, `companies/${company.id}/discounts/${discountToSave.id}`);
    } else {
      discountRef = doc(collection(firestore, `companies/${company.id}/discounts`));
      discountToSave.id = discountRef.id;
    }

    discountToSave.staged = false;
    const discountSnapshot = yield call(setDoc, discountRef, discountToSave);
    yield put(appActions.saveDiscountSuccess());
  } catch (e) {
    console.error(e);
    yield put(appActions.saveDiscountFailure(e));
  }
}

export function* saveProduct(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    let productToSave = action.params.product;
    let productRef;
    if (productToSave.id) {
      productRef = doc(firestore, `companies/${company.id}/products/${productToSave.id}`);
    } else {
      productRef = doc(collection(firestore, `companies/${company.id}/products`));
      productToSave.id = productRef.id;
    }

    productToSave.staged = false;

    const productSnapshot = yield call(setDoc, productRef, productToSave);
    yield put(appActions.saveProductSuccess());
  } catch (e) {
    console.error(e);
    yield put(appActions.saveProductFailure(e));
  }
}

export function* deleteProduct(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    let productToDelete = action.params.product;
    let productRef;
    if (productToDelete) {
      productRef = doc(firestore, `companies/${company.id}/products/${productToDelete.id}`);
      yield call(updateDoc, productRef, {active: false});
      yield put(appActions.deleteProductSuccess());
    } else {
      throw "No product to delete"
    }
  } catch (e) {
    console.error(e);
    yield put(appActions.deleteProductFailure(e));
  }
}

export function* saveVariant(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    let variantToSave = action.params.variant;
    let product = action.params.product;
    let variantRef;
    if (variantToSave.id) {
      variantRef = doc(firestore, `companies/${company.id}/products/${product.id}/variants/${variantToSave.id}`);
    } else {
      variantRef = doc(collection(firestore, `companies/${company.id}/products/${product.id}/variants`));
      variantToSave.id = variantRef.id;
    }

    variantToSave.staged = false;

    const variantSnapshot = yield call(setDoc, variantRef, variantToSave);
    yield put(appActions.saveVariantSuccess());
  } catch (e) {
    console.error(e);
    yield put(appActions.saveVariantFailure(e));
  }
}

export function* deleteVariant(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    let variantToDelete = action.params.variant;
    let productParent = action.params.product;
    let variantRef;
    if (variantToDelete) {
      variantRef = doc(firestore, `companies/${company.id}/products/${productParent.id}/variants/${variantToDelete.id}`);
      yield call(deleteDoc, variantRef);
      yield put(appActions.deleteVariantSuccess());
    } else {
      throw "No variant to delete"
    }
  } catch (e) {
    console.error(e);
    yield put(appActions.deleteVariantFailure(e));
  }
}

export function* deleteDiscount(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    let discountToDelete = action.params.discount;
    let discountRef;
    debugger;
    if (discountToDelete) {
      discountRef = doc(firestore, `companies/${company.id}/discounts/${discountToDelete.id}`);
      yield call(deleteDoc, discountRef);
      yield put(appActions.deleteDiscountSuccess());
    } else {
      throw "No variant to delete"
    }
  } catch (e) {
    console.error(e);
    yield put(appActions.deleteDiscountFailure(e));
  }
}


export function* fetchWorkflows(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    const companyId = company.id;
    const workflowRef = collection(firestore, `companies/${companyId}/workflows`);
    const workflowSnapshot = yield call(getDocs, workflowRef);
    const workflows = firestoreUtils.collectionToMap(workflowSnapshot);
    console.log("loaded workflows: ", workflows, companyId);
    yield put(appActions.fetchWorkflowsSuccess(workflows));
  } catch (e) {
    console.error(e);
    yield put(appActions.fetchWorkflowsFailure(e));
  }
}

export function* saveWorkflow(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    let workflowToSave = action.params.workflow;
    let workflowRef;
    if (workflowToSave.id) {
      workflowRef = doc(firestore, `companies/${company.id}/workflows/${workflowToSave.id}`);
    } else {
      workflowRef = doc(collection(firestore, `companies/${company.id}/workflows`));
      workflowToSave.id = workflowRef.id;
    }

    workflowToSave.staged = false;
    workflowToSave.hash = EntityUtils.generateID();
    const workflowSnapshot = yield call(setDoc, workflowRef, workflowToSave);
    yield put(appActions.saveWorkflowSuccess());
  } catch (e) {
    console.error(e);
    yield put(appActions.saveWorkflowFailure(e));
  }
}

export function* syncWorkflows(action) {

  try {
    const company = yield select(appSelector.selectCompany());
    if (company != null) {

      let q = query(collection(firestore, `companies/${company.id}/workflows`), where('active', '==', true));

      yield fork(
        rsf.firestore.syncCollection,
        q,
        {
          successActionCreator: appActions.fetchWorkflowsSuccess,
          transform: firestoreUtils.simpleTransform
        }
      )
    }
  } catch (e) {
    debugger;
    console.error(e);
  }

}


export function* deleteWorkflow(action) {
  try {
    let company = yield select(appSelector.selectCompany());
    let workflowToDelete = action.params.workflow;
    let workflowRef;
    if (workflowToDelete) {
      workflowRef = doc(firestore, `companies/${company.id}/workflows/${workflowToDelete.id}`);
      yield call(updateDoc, workflowRef, {active: false});
      yield put(appActions.deleteWorkflowSuccess());
    } else {
      throw "No workflow to delete"
    }
  } catch (e) {
    console.error(e);
    yield put(appActions.deleteWorkflowFailure(e));
  }
}

export function* saveConnectedAccount(action) {
  try {
    const {type} = action.params;
    const company = yield select(appSelector.selectCompany());
    if (type === 'add') {
      const {accountId} = action.params;
      let decryptor = decrypt("drink_more_ovaltine");
      let id = decryptor(accountId);
      let companyRef = doc(firestore, `companies/${id}`);
      let companySnap = yield call(getDoc, companyRef);
      if (companySnap.exists()) {
        let ref = doc(firestore, `connectedAccounts/${company.id}`);
        let snap = yield call(getDoc, ref);
        if (snap.exists()) {
          yield call(updateDoc, ref, {
            connectedAccountIds: arrayUnion(id)
          });
        } else {
          yield call(setDoc, ref, {
            connectedAccountIds: [id]
          });
        }

        let accountRef = doc(firestore, `companies/${id}`);
        let accountSnap = yield call(getDoc, accountRef);
        if (accountSnap.exists()) {
          yield call(updateDoc, accountRef, {
            parentConnectedAccount: company.id
          })
        }

        yield put(appActions.saveConnectedAccountSuccess({}));
      } else {
        yield put(appActions.saveConnectedAccountFailure({
          accountFailedToAdd: accountId
        }));
      }
    }
  } catch (e) {
    yield put(appActions.saveConnectedAccountFailure({
      error: e
    }));
  }
}

export function* fetchConnectedAccountObjects(action) {
  let connectedAccounts = yield select(appSelector.selectConnectedAccounts());
  let connectedCompanies = {};

  try {
    let ids = connectedAccounts.connectedAccountIds;
    if (ids) {
      for (let i = 0; i < ids.length; i++) {
        let accountId = ids[i];
        let accountRef = doc(firestore, `companies/${accountId}`);
        let accountSnap = yield call(getDoc, accountRef);
        if (accountSnap.exists()) {
          let accountData = accountSnap.data();
          connectedCompanies[accountData.id] = accountData;
        }
      }
    }

    yield put(appActions.fetchConnectedCompaniesSuccess(connectedCompanies));
  } catch (e) {
    yield put(appActions.fetchConnectedCompaniesFailure(e));
  }

  return connectedCompanies;
}

export function* syncConnectedAccounts(action) {
  try {
    const company = yield select(appSelector.selectCompany());
    if (company != null) {
      let id = company.id
      yield fork(
        rsf.firestore.syncDocument,
        `connectedAccounts/${id}`,
        {
          successActionCreator: appActions.fetchConnectedAccountsSuccess,
          transform: (document) => {
            if (document.exists()) {
              let data = document.data();
              let ids = data.connectedAccountIds;

              // Remove self
              if (ids.indexOf(company.id) > -1) {
                ids.splice(ids.indexOf(company.id), 1);
              }

              // Add possible parent
              if (company.parentConnectedAccount) {
                ids.push(company.parentConnectedAccount);
              }

              data.connectedAccountIds = ids;
              return data;
            } else {
              return {};
            }
          }
        }
      )
    }
  } catch (e) {
    debugger;
    console.error(e);
  }
}

export default function* defaultSaga() {
  yield takeLatest(LOAD_CUSTOMERS_ACTION, loadCustomers);
  yield takeLatest(CREATE_CUSTOMER_ACTION, createCustomer);
  yield takeLatest(UPDATE_CUSTOMER_ACTION, updateCustomer);
  yield takeLatest(DELETE_CUSTOMER_ACTION, deleteCustomer);
  yield takeLatest(LOAD_COMPANY_ACTION, loadCompany);
  yield takeLatest(CREATE_COMPANY_ACTION, createCompany);
  yield takeLatest(UPDATE_COMPANY_ACTION, updateCompany);
  yield takeLatest(UPDATE_PLAN_ACTION, updatePlan);
  yield takeLatest(AUTH_USER_SET, loadProfile);
  yield takeLatest(SUBSCRIBE_ACTION, subscribe)
  yield takeLatest(STRIPE_CONNECT_ACTION, stripeConnect)
  yield takeLatest(LOAD_CC_GATEWAY_ACTION, loadccGateway)
  yield takeLatest(CREATE_DOCUMENT_ACTION, createDocument);
  yield takeLatest(UPDATE_DOCUMENT_ACTION, updateDocument);
  yield takeLatest(DELETE_DOCUMENT_ACTION, deleteDocument);
  yield takeLatest(CREATE_DOCUMENT_INSTANCE_ACTION, createDocumentInstance);
  yield takeLatest(UPDATE_DOCUMENT_INSTANCE_ACTION, updateDocumentInstance);
  yield takeLatest(DELETE_DOCUMENT_INSTANCE_ACTION, deleteDocumentInstance);
  yield takeLatest(SHARE_DOCUMENT_INSTANCE_ACTION, shareDocumentInstance);
  yield takeLatest(LOAD_COMPANY_MEMBERS_ACTION, loadCompanyMembers);
  yield takeLatest(QB_SYNC_INVOICES_ACTION, QBSyncInvoices);
  yield takeLatest(QB_SYNC_CUSTOMERS_ACTION, QBSyncCustomers);
  yield takeLatest(UPDATE_USER_ACTION, updateUser);
  yield takeLatest(FETCH_DISCOUNTS, fetchVariants);
  yield takeLatest(FETCH_VARIANTS, fetchVariants);
  yield takeLatest(FETCH_PRODUCTS, fetchProducts);
  yield takeLatest(SYNC_PRODUCTS, syncProducts)
  yield takeEvery(SYNC_VARIANTS, syncVariants);
  yield takeLatest(SYNC_DISCOUNTS, syncDiscounts);
  yield takeLatest(DELETE_PRODUCT, deleteProduct);
  yield takeLatest(DELETE_VARIANT, deleteVariant);
  yield takeLatest(DELETE_DISCOUNT, deleteDiscount);
  yield takeLatest(SAVE_PRODUCT, saveProduct);
  yield takeLatest(SAVE_DISCOUNT, saveDiscount);
  // Use takeEvery (not takeLatest) so bulk operations like availability
  // "Make Siblings Match" / "Make Everything Match" — which dispatch one
  // SAVE_VARIANT per product/variant in a loop — all run to completion.
  // takeLatest would cancel every in-flight save except the last dispatched one.
  yield takeEvery(SAVE_VARIANT, saveVariant);
  yield takeLatest(FETCH_WORKFLOWS, fetchWorkflows);
  yield takeLatest(SAVE_WORKFLOW, saveWorkflow);
  yield takeLatest(SYNC_WORKFLOWS, syncWorkflows);
  yield takeLatest(UPDATE_USER_CONFIGS, updateUserConfig);
  yield takeLatest(SAVE_CONNECTED_ACCOUNT, saveConnectedAccount);
  yield takeLatest(SYNC_CONNECTED_ACCOUNTS, syncConnectedAccounts);
  yield takeLatest(FETCH_CONNECTED_ACCOUNTS_SUCCESS, fetchConnectedAccountObjects);
  yield takeLatest(FETCH_CONNECTED_COMPANIES, fetchConnectedAccountObjects);
  yield takeLatest(DELETE_WORKFLOW, deleteWorkflow);
  yield takeLatest(FETCH_CART_CONFIGURATIONS, fetchCartConfigurations);
  yield takeLatest(FETCH_EMBED_CONFIGURATIONS, fetchEmbedConfigurations);
  yield takeLatest(SYNC_EMBED_CONFIGURATIONS, syncEmbedConfigurations);
  yield takeLatest(SYNC_CART_CONFIGURATIONS, syncCartConfigurations);
  yield takeLatest(DELETE_EMBED_CONFIGURATION, deleteEmbedConfiguration);
  yield takeLatest(DELETE_CART_CONFIGURATION, deleteCartConfiguration);
  yield takeLatest(SAVE_EMBED_CONFIGURATION, saveEmbedConfiguration);
  yield takeLatest(SAVE_CART_CONFIGURATION, saveCartConfiguration);
  yield takeLatest(FETCH_API_KEYS, fetchApiKeys);
  yield takeLatest('FAILURE', failureNotifier);
}
